const POSITIVE = '#045791'//'#9bbb59'
const NEUTRAL = '#1d86ce'//'#a6a6a6'
const NEGATIVE = '#fc5e06'//'#ff0200'
const DEFAULT_BAR = '#0a3579'
const DEFAULT_LINE = '#1e7bbb'
const TABLE_BACKGROUND = '#00a6f3'
const TABLE_BORDER = '#3bb4f6'
const TABLE_HEADER = '#000000'
const TABLE_DATA = '#feb236'
const APCO = '#f47c31'
const SENSIKA = '#001528'
const WHITE = '#ffffff'
const BLACK = '#000000'
const DARK_SHADOW = '#000000D0'
const LIGHT_SHADOW = '#dcdde1'// '#ecf0f1' // '#7090B05F'

export default {
    POSITIVE,
    NEUTRAL,
    NEGATIVE,
    DEFAULT_BAR,
    DEFAULT_LINE,
    TABLE_BACKGROUND,
    TABLE_BORDER,
    TABLE_HEADER,
    TABLE_DATA,
    APCO,
    WHITE,
    SENSIKA,
    DARK_SHADOW,
    LIGHT_SHADOW,
    BLACK
}